/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

require('../../modules/es6.reflect.apply');
module.exports = require('../../modules/_core').Reflect.apply;




//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/reflect/apply.js
// module id = 1081
// module chunks = 60